import { NavigationType } from '@hmax-order/shared/enums';
import { defaultNavigation } from './data/company-nav-data';
import { organizationNavigation } from './data/organization-nav-data';
import { superNavigation } from './data/super-nav-data';
import { demoViewerNavigation } from './data/demo-viewer-nav-data';

export function getNavigation(type?: NavigationType | string): any[] {
  switch (type) {
    case 'super':
      return superNavigation;
    case 'organization':
      return organizationNavigation;
    case 'company':
      return defaultNavigation;
    case 'demo-viewer':
      return demoViewerNavigation;
    default:
      return defaultNavigation;
  }
}
